"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bbox2Edges = void 0;
var utils_1 = require("../../../utils");
var bbox_edge_1 = require("../../types/record/bbox-edge");
var bbox2Edges = function (bbox) {
    var _a = bbox.rect, top = _a.top, left = _a.left, width = _a.width, height = _a.height;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var x0 = left;
    var x1 = left + halfWidth;
    var x2 = left + width;
    var y0 = top;
    var y1 = top + halfHeight;
    var y2 = top + height;
    return (0, utils_1.IList)([
        (0, bbox_edge_1.IBboxEdge)({
            centerPos: (0, utils_1.IPos)({ x: x1, y: y0 }),
            location: 'n',
            halfLength: halfWidth,
            parent: bbox
        }),
        (0, bbox_edge_1.IBboxEdge)({
            centerPos: (0, utils_1.IPos)({ x: x0, y: y1 }),
            location: 'w',
            halfLength: halfHeight,
            parent: bbox
        }),
        (0, bbox_edge_1.IBboxEdge)({
            centerPos: (0, utils_1.IPos)({ x: x2, y: y1 }),
            location: 'e',
            halfLength: halfHeight,
            parent: bbox
        }),
        (0, bbox_edge_1.IBboxEdge)({
            centerPos: (0, utils_1.IPos)({ x: x1, y: y2 }),
            location: 's',
            halfLength: halfWidth,
            parent: bbox
        })
    ]);
};
exports.bbox2Edges = bbox2Edges;
